import { Component, input } from '@angular/core';
import { ComponentBase } from '@Common';

export interface LegendData {
	label: string;
	count: number;
	style: Partial<CSSStyleDeclaration>;
}

@Component({
	selector: 'legend',
	templateUrl: './legend.component.html',
	styleUrls: ['./legend.component.scss'],
	standalone: false,
})
export class LegendComponent extends ComponentBase {
	public title = input('Legend');
	public items = input<LegendData[]>([]);
	public itemLabel = input('');
}
